export default __webpack_public_path__ + "static/media/IMG_7629.71f43ea0.jpeg";